// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__tKpJn","copyContainer":"footer_copyContainer__t9+iZ","links":"footer_links__dobSd"};